import { useTenant } from '@rewardops/auth/src/client'

import { trpcApiForTenant } from '~/utils/trpc-api'

export const useApi = () => {
  const tenant = useTenant()
  const host = tenant.publicUrl
  const api = trpcApiForTenant(host)
  return { api, tenant }
}
